"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _atoms = require("../../atoms");
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var SpacingButton = (0, _styledComponents["default"])(_atoms.View)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-right: var(--spacing-2); \n"])));
var _default = exports["default"] = SpacingButton;